import React, { useState } from 'react';
import { useTripContext } from '../TripContext';
import { useParams } from 'react-router-dom';
import '../../../css/Insurances/Insurances.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck, faShieldHalved } from "@fortawesome/free-solid-svg-icons";
import getParticipantStatusStyle, { ParticipantStatus } from '../../../utils/getParticipantStatusStyle';

const Insurances = () => {
  const { tripData } = useTripContext();
  const { variantguid } = useParams();
  const [expandedRow, setExpandedRow] = useState(null);

  const toggleExpand = (guid) => {
    setExpandedRow(prev => prev === guid ? null : guid);
  };

  if (!tripData) {
    return <p className="no-data-message">Brak danych o wycieczce.</p>;
  }

  let registrations = tripData.registrations || [];

  const allVariants = [...new Map(registrations.map(r => [r.variantGuid, {
    guid: r.variantGuid,
    name: r.variantName
  }])).values()];

  const participants = registrations
    .filter(r => r.confirmedAt !== null)
    .flatMap(r => (r.participants || [])
      .filter(p => p.insurance && p.status !== ParticipantStatus.Deleted)
    )
    .sort((a, b) => a.preferredName.localeCompare(b.preferredName));

  const renderCoverageIcon = (value) => {
    if (value === true) {
      return <FontAwesomeIcon icon={faCircleCheck} className="insurance-icon-green" />;
    } else if (value === false) {
      return <FontAwesomeIcon icon={faCircleCheck} className="insurance-icon-gray" />;
    } else {
      return <span className="insurance-icon-dash">–</span>;
    }
  };

  return (
    <div className="insurance-page">
      {participants.length === 0 ? (
        <div className="insurance-empty-state"><span className="insurance-empty-icon"><FontAwesomeIcon icon={faShieldHalved} /></span><strong>Brak danych ubezpieczeniowych</strong><p>Żadna z osób uczestniczących nie ma jeszcze uzupełnionych informacji o ubezpieczeniu.</p></div>
      ) : (
        <div className="insurance-table-wrapper">
          <table className="insurance-table">
            <thead>
              <tr>
                <th><span className="insurance-participant-heading">Uczestnix <span className="insurance-count">({participants.length})</span></span></th>
                <th>NNW</th>
                <th>KR</th>
                <th>Zwyżka</th>
              </tr>
            </thead>
            <tbody>
              {participants.map(p => {
                const statusStyle = getParticipantStatusStyle(p.status);
                return (
                  <React.Fragment key={p.guid}>
                    <tr
                      className={`insurance-participant-row ${statusStyle.statusClass} ${expandedRow === p.guid ? "expanded" : ""}`}
                      onClick={() => toggleExpand(p.guid)}
                    >
                      <td className="insurance-name-cell">
                        <i className={`fa-solid ${statusStyle.icon} insurance-user-icon ${statusStyle.statusClass}`} />
                        <span className={p.status === ParticipantStatus.Cancelled ? "crossed-name" : ""}>
                          {p.preferredName}
                        </span>
                      </td>
                      <td className="insurance-symbol-cell">{renderCoverageIcon(p.insurance.hasNNWCoverage)}</td>
                      <td className="insurance-symbol-cell">{renderCoverageIcon(p.insurance.hasKRCoverage)}</td>
                      <td className="insurance-symbol-cell">
                        {p.insurance.isChronicIllness === true && (
                          <FontAwesomeIcon icon={faCircleCheck} className="insurance-icon-green" />
                        )}
                      </td>
                    </tr>
                    {expandedRow === p.guid && (
                      <tr className="insurance-extra-row">
                        <td colSpan="4" className="insurance-extra-cell">
                          {p.nnwCost > 0 && <span><b>NNW:</b> {p.nnwCost} zł </span>}
                          {p.krCost > 0 && <span><b>KR:</b> {p.krCost} zł</span>}
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default Insurances;
